import { render } from "./Procedimiento_RecetaDet.vue?vue&type=template&id=43af2710"
import script from "./Procedimiento_RecetaDet.vue?vue&type=script&lang=js"
export * from "./Procedimiento_RecetaDet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__